<template>
  <page class="bg-color">
    <div class="about-me">
      <div class="my-head" v-if="isLogin">
        <div class="head-img">
          <img :src="userInfo.headUrl || defaultHead" alt="" />
          <div class="user-name">
            <span class="font-w">{{ userInfo.nickName || '无' }}</span>
            <span>{{ loginType[userInfo.loginType] || '未知' }}</span>
          </div>
        </div>
        <div class="login-out" @click="clickChangeAccount">切换帐号</div>
      </div>
      <div class="my-order">
        <div class="order-title">
          <span>我的订单</span>
          <a href="javascript:;" @click="toMyOrder(0)" class="to-all-order">
            全部
            <van-icon name="arrow" class="right-arrow" />
          </a>
        </div>
        <div
          v-show="isLogin"
          class="logined"
          v-for="list in myOrderMessage"
          :key="list.id"
          @click="toOrderDetail(list)"
        >
          <div class="pic-box">
            <div class="img"><img :src="myList[0].skuThumb" alt="" /></div>
            <div class="card-msg">
              <p class="card-name">{{ list.orderGoodss[0].goodsName }}</p>
              <p class="card-num">￥{{ goodsPrice }} X {{ goodsNum }}</p>
              <p class="card-date">
                <formatData class="time" :date="list.addTime * 1000" />
                <span class="pic-price">￥{{ goodsAmount }}</span>
              </p>
            </div>
          </div>
        </div>
        <ul class="order-part cf">
          <li class="order-list-item">
            <img src="@/assets/payment.png" class="icon" alt="" @click="toMyOrder(1)" />
            <i class="tag" v-if="waitPayCount > 0">{{ waitPayCount }}</i>
            <span class="item-name">待付款</span>
          </li>
          <li class="order-list-item">
            <img src="@/assets/selling.png" class="icon" alt="" @click="toMyOrder(2)" />
            <i class="tag" v-if="waitShippingCount > 0">{{ waitShippingCount }}</i>
            <!-- <van-icon class="icon" :info="waitShippingCount> 0 ? waitShippingCount : ''" @click="toMyOrder(2)" name="send-gift-o"/> -->
            <span class="item-name">待发货</span>
          </li>
          <li class="order-list-item">
            <img src="@/assets/selling_car.png" class="icon" alt="" @click="toMyOrder(3)" />
            <i class="tag" v-if="waitReceiveCount > 0">{{ waitReceiveCount }}</i>
            <span class="item-name">待收货</span>
          </li>
          <li class="order-list-item">
            <img src="@/assets/received.png" class="icon" alt="" @click="toMyOrder(4)" />
            <i class="tag" v-if="alreadyReceivedCount > 0">{{ alreadyReceivedCount }}</i>
            <span class="item-name">已收货</span>
          </li>
        </ul>
      </div>
      <div class="my-order tool-service">
        <div class="order-title">
          <span>工具与服务</span>
        </div>
        <ul class="order-part cf">
          <li class="order-list-item">
            <img src="@/assets/aftersales.png" class="icon" alt="" @click="clickShouHou" />
            <span class="item-name">售后记录</span>
          </li>
          <li class="order-list-item coupon">
            <img src="@/assets/coupon_2.png" class="icon" alt="" @click="toDiscountCardPage" />
            <span class="item-name">优惠券</span>
          </li>
          <li class="order-list-item">
            <img src="@/assets/local2x.png" class="icon" alt="" @click="toAddress" />
            <span class="item-name">地址管理</span>
          </li>
        </ul>
      </div>
    </div>
    <!-- <popup pageFrom="personCenter"></popup> -->
  </page>
</template>
<script>
import formatData from '@/components/formatData'
// import popup from './popup.vue'
export default {
  name: 'store-users',
  components: {
    formatData
  },
  computed: {
    ccLogParams() {
      return {
        // user_type: this.isFormalEmp,
        user_empNo: this.getEmpNo || '',
        frontPageName: this.getFromUrl,
        page_name: '我的',
        form: 'H5'
      }
    }
  },
  data() {
    return {
      loginType: {
        weixin: '微信',
        qq: 'QQ',
        phoneDynameic: '手机号'
      },
      defaultHead: require('@/assets/head2x.png'),
      waitPayCount: null,
      alreadyReceivedCount: null,
      waitReceiveCount: null,
      waitShippingCount: null,
      count: 1,
      residue: 999,
      isLogin: this.$service.state.inited,
      cardNum: 0,
      infoForm: {},
      userInfo: this.$service.state.user,
      goodsNum: 0,
      goodsPrice: 0.0,
      myOrderMessage: [],
      myList: [{}],
      goodsAmount: 0,
      empNo: ''
    }
  },
  methods: {
    clickChangeAccount() {
      this.$constants.submitccLog('partner_mini_page_click', '我的-点击切换账号', {
        ...this.ccLogParams,
        button_name: '切换账号'
      })
      this.$signIn()
    },
    clickShouHou() {
      this.$constants.submitccLog('partner_mini_page_click', '我的-点击售后记录', {
        ...this.ccLogParams,
        button_name: '售后记录'
      })
      this.$router.push({ name: 'aftersales-list' })
    },
    toMyOrder(id) {
      let button_name = ''
      switch (id) {
        case 0:
          button_name = '我的订单:全部'
          break
        case 1:
          button_name = '待付款'
          break
        case 2:
          button_name = '待发货'
          break
        case 3:
          button_name = '待收货'
          break
        case 4:
          button_name = '已收货'
          break
      }
      this.$constants.submitccLog('partner_mini_page_click', '我的-点击' + button_name, {
        ...this.ccLogParams,
        button_name
      })
      this.$router.push({ name: 'my-order', query: { id: id } })
    },
    // id 为2区分我的地址还是编辑地址
    toAddress(id) {
      this.$constants.submitccLog('partner_mini_page_click', '我的-点击地址管理', {
        ...this.ccLogParams,
        button_name: '地址管理'
      })
      this.$router.push({ name: 'address', query: { id: 2 } })
    },
    toOrderDetail(list) {
      this.$constants.submitccLog('partner_mini_page_click', '我的-点击进入订单详情', {
        ...this.ccLogParams,
        button_name: '进入订单详情'
      })
      console.log('进入订单详情', list)
      this.$router.push({
        name: 'order-detail',
        query: {
          orderSn: list.orderCode,
          goodsId: list.orderGoodss[0].goodsId,
          type: list.actType,
          sourceFlag: list.sourceFlag
        }
      })
    },
    toDiscountCardPage() {
      this.$constants.submitccLog('partner_mini_page_click', '我的-点击优惠券', {
        ...this.ccLogParams,
        button_name: '优惠券'
      })
      this.$router.push({ name: 'discount-card' })
    },
    getOrderNumber() {
      this.$service.getOrderNumber().then((res) => {
        if (res.data) {
          this.alreadyReceivedCount = res.data.alreadyReceivedCount
          this.waitReceiveCount = res.data.waitReceiveCount
          this.waitShippingCount = res.data.waitShippingCount
          this.waitPayCount = res.data.waitPayCount
        }
      })
    },
    getOrderList() {
      let params = {}
      params.orderStatus = 5
      this.$service.getOrderList(params).then((res) => {
        this.myOrder = res.data.list.forEach((item, index) => {
          if (index === 0) {
            this.goodsNum = item.orderGoodss[0].goodsNum
            this.goodsPrice = item.orderGoodss[0].skuDto.marketPrice
            this.goodsAmount = item.goodsAmount
            this.myOrderMessage.push(res.data.list[0])
            // this.myOrderMessage = item.orderGoodss.map(item => {
            //   return item.ecsOrderMovieActiveDtoList
            // })
            this.myList = item.orderGoodss.map((item) => {
              return item.skuDto
            })
          }
        })
      })
    }
  },
  mounted() {
    this.getOrderNumber()
    this.getOrderList()
  }
}
</script>
<style lang="stylus" scoped>
// .my-users
.about-me {
  padding-bottom: 63px;
  // background #EFEFF4
  // min-height 100vh
}

.my-head {
  width: 100%;
  height: 100px;
  position: relative;
  background: #fff;
}

.my-head .user-name {
  float: left;
  padding-top: 15px;
}

.my-head .head-img {
  // width 250px
  padding: 15px 10px 17px 20px;
  float: left;
}

>>> .login-btn {
  height: 22px;
  border: none;
  color: #333333;
  font-size: 16px;
  background: none;
  float: left;
  margin: 20px 0 10px 10px;
  font-weight: 600;
}

>>> .user-name {
  margin-left: 20px;
  padding-top: 10px;
}

>>> .user-name span {
  font-size: 14px;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 257px;
  white-space: nowrap;
}

.my-head .head-img img {
  width: 66px;
  height: 66px;
  border-radius: 50%;
  float: left;
}

.setting {
  width: 47px;
  height: 32px;
  line-height: 32px;
  padding-left: 10px;
  color: #4d555d;
  backgrouund: #cdcdcd;
  border: 1px solid #cdcdcd;
  border-right: none;
  border-top-left-radius: 16px;
  border-bottom-left-radius: 16px;
  font-size: 16px;
  position: absolute;
  right: 0;
  top: 34px;
}

.my-order {
  margin-top: 12px;
  background: #ffffff;
  width: 100%;
  overflow: hidden;
}

.order-title {
  height: 44px;
  line-height: 44px;
  padding-left: 15px;
  border-bottom: 1px solid #EFEFF4;
  position: relative;
}

.order-title span {
  font-size: 14px;
  color: #3333 3;
  float: left;
}

.order-title .to-all-order {
  float: right;
  color: #666;
  font-size: 14px;
  padding-right: 15px;
  padding-top: 1px;
}

>>> .right-arrow {
  width: 24px;
  height: 24px;
  display: inline-block;
  margin-top: 10px;
  text-align: center;
  line-height: 24px;
  position: absolute;
  top: 0px;
  right: 5px;
}

.order-part {
  width: 100%;
  // display flex
  // text-align center
  // justify-content middle
  // align-items center
  // height 90px
  // overflow hidden
  // flex-wrap wrap
}

.order-part .order-list-item {
  width: 25%;
  float: left;
  text-align: center;
  height: 70px;
  margin-top: 15px;
  position: relative;
}

.order-list-item .icon {
  width: 28px;
  height: 28px;
  margin-top: 5px;
}

.order-list-item .icon_vant {
  font-size: 32px;
}

.order-list-item .tag {
  position: absolute;
  font-style: normal;
  width: 15px;
  height: 15px;
  border: 1px solid #FC6C00FF;
  border-radius: 50% 50%;
  right: 23px;
  top: -5px;
  color: #FC6C00FF;
  font-size: 10px;
  z-index: 10;
  display: block;
}

.order-list-item span {
  font-size: 14px;
  color: #333333;
  display: block;
  // line-height 1px
  height: 30px;
}

.order-list-item .item-name {
  font-size: 14px;
  color: #333333;
  display: block;
  height: 30px;
  position: absolute;
  width: 100%;
  left: 10%;
  margin-left: -11%;
  bottom: 0;
}

.font-w {
  font-weight: 600;
}

.logined {
  width: 100%;
}

.pic-box {
  height: 79px;
  padding: 10px 0;
  border-bottom: 1px solid #e5e5e5;

  .img {
    width: 80px;
    height: 80px;
    float: left;
    background: #eee;

    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  .card-msg {
    margin-left: 10px;
    float: left;
    width: 255px;
    position: relative;
    height: 80px;

    .card-name {
      color: #333;
      font-size: 14px;
      font-weight: 600;
      margin: 0;
      line-height: 20px;
      max-height: 40px;
      overflow: hidden;
    }

    .card-num {
      color: #666;
      font-size: 12px;
      height: 18px;
      line-height: 18px;
    }

    .card-date {
      font-size: 12px;
      line-height: 18px;
      height: 18px;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;

      .time {
        color: #999;
        float: left;
        font-size: 12px;
      }

      .pic-price {
        font-size: 14px;
        color: #FC4C00;
        font-weight: 600;
        float: right;
      }
    }
  }
}

>>> img {
  width: 100%;
  height: 100%;
}

>>> span {
  font-size: 14px;
  color: #333;
}

.bg {
  background: rgba(236, 236, 236, 1);
  width: 132px;
  height: 91px;
  padding: 10px;
}

.login-out {
  position: absolute;
  right: 0;
  top: 36px;
  font-size: 12px;
  background: #eae9e9;
  color: #666;
  height: 25px;
  line-height: 25px;
  padding: 0 5px 0 10px;
  border-radius: 8px 0 0 8px;
}
</style>
